import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SubscriptionsListPage from './SubscriptionsListPage';

export default function SubscriptionsRoutes() {
  return (
    <Routes>
      <Route index element={<SubscriptionsListPage />} />
    </Routes>
  );
}
